module.exports = __webpack_public_path__ + "static/media/image_slider_home_02.f41f9451.jpg";